import { render, staticRenderFns } from "./GroupChannel.vue?vue&type=template&id=96bb6608"
import script from "./GroupChannel.vue?vue&type=script&lang=js"
export * from "./GroupChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports